<template>
    <DCard
        :title="__('orders.show.order_person_details')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow :label="__('orders.show.user_id')">
                    {{ order.rawContents?.user_id ?? '' }}
                </DFormRow>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>

import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    }
})

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const switchButtonForm = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    switchButtonForm.columns = flattenColumns(columns.value)

    switchButtonForm.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}
</script>

<style scoped>

</style>
